const config = [
  {
    title: {
      id: 999,
      fallback: 'What do I need to do?',
    },
    description: [
      {
        id: 999,
        fallback: 'You need to migrate all your existing LP Tokens to a new type of LP Token.',
      },
      {
        id: 999,
        fallback: 'Just follow the method shown above on this page.',
      },
    ],
  },
  {
    title: {
      id: 999,
      fallback: 'When should I migrate?',
    },
    description: [
      {
        id: 999,
        fallback:
          'As soon as possible. If you don’t migrate, you’ll stop earning any rewards from the old type of LP tokens.',
      },
    ],
  },
  {
    title: { id: 999, fallback: 'What’s happening?' },
    description: [
      {
        id: 999,
        fallback:
          'In order to upgrade to a new exchange system, PancakeSwap has transferred (“migrated”) two of our current smart contracts to new, upgraded contracts.',
      },
      {
        id: 999,
        fallback:
          'Put simply, we’ve created a new set of LP Tokens, and our farms and exchange are now supporting the new type instead of the old ones.',
      },
      {
        id: 999,
        fallback: 'As such, you need to migrate to the new type, so you can keep earning!',
      },
    ],
  },
  {
    title: { id: 999, fallback: 'Do I need to do this for all my LP Tokens?' },
    description: [
      {
        id: 999,
        fallback: 'You must complete migration of your LP tokens to keep earning:',
      },
      {
        id: 999,
        fallback: 'Trading fees for your LP on the exchange',
      },
      {
        id: 999,
        fallback: 'Yield from farms',
      },
      {
        id: 999,
        fallback: 'If you don’t migrate, those LP tokens won’t earn you anything.',
      },
    ],
  },
  {
    title: { id: 999, fallback: 'Do I need to do anything with Syrup Pools?' },
    description: [
      {
        id: 999,
        fallback: 'No, Syrup Pools won’t be affected. You can still keep earning from the same Syrup Pools as usual.',
      },
    ],
  },
  {
    title: { id: 999, fallback: 'What if I’m using a vault or yield aggregator?' },
    description: [
      {
        id: 999,
        fallback:
          'Check with your chosen project for what you need to do. Most major BSC projects are aware of the situation, and may be handling it differently.',
      },
      {
        id: 999,
        fallback: 'Please follow your chosen project’s social media and community for specific answers.',
      },
    ],
  },
  {
    title: { id: 999, fallback: 'Will I lose pending rewards/yield?' },
    description: [
      {
        id: 999,
        fallback: 'No, you won’t lose any yield or other rewards that you have already earned.',
      },
      {
        id: 999,
        fallback:
          'You will only lose the opportunity to earn rewards from farms and trading fees if you don’t migrate. Migrate early to maximize your rewards!',
      },
    ],
  },
]

export default config
